import { acceptHMRUpdate, defineStore } from 'pinia';

export const usePresenceStore = defineStore('presence', {
  state: () => ({
    selectedWorker: null,
  }),

  persist: true,
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(usePresenceStore, import.meta.webpackHot));
}
